import {
    BOOKING_GETALL_SUCCESS,
    BOOKING_GETALL_FAIL,
    BOOKING_UPSERT_SUCCESS,
    BOOKING_UPSERT_FAIL,
    BOOKING_DELETE_SUCCESS,
    BOOKING_DELETE_FAIL,
    SET_MESSAGE,
    BOOKING_GET_ONE_FAIL,
    BOOKING_GET_ONE_SUCCESS
} from "./types";

import BookingService from "../services/booking.service";

export const getBookings = (id_user, currentPage, pageSize) => (dispatch) => {
    return BookingService.getBookings(id_user, currentPage, pageSize).then(
        (result) => {
            dispatch({
                type: BOOKING_GETALL_SUCCESS,
                payload: { bookings: result.data, total: result.totalRows },
            });
            return Promise.resolve();
        },
        (error) => {
            dispatch({ type: BOOKING_GETALL_FAIL });
            dispatch({
                type: SET_MESSAGE,
                payload: `Bookings retrieval failed : ${error}`,
            });
            return Promise.reject();
        }
    );
};

export const getBooking = (id, id_user) => (dispatch) => {
    return BookingService.getBooking(id, id_user).then(
        (data) => {
            return data
        },
        (error) => {
            return null
        }
    );
};

export const upsertBooking = (booking) => (dispatch) => {
    return BookingService.upsertBooking(booking).then(
        (data) => {
            dispatch({ type: BOOKING_UPSERT_SUCCESS, payload: data });
            return Promise.resolve();
        },
        (error) => {
            console.log(error)
            dispatch({ type: BOOKING_UPSERT_FAIL });
            dispatch({
                type: SET_MESSAGE,
                payload: `Booking upsert failed - ${error}`,
            });
            return Promise.reject(error);
        }
    );
};

export const deleteBooking = (Booking_id) => (dispatch) => {
    return BookingService.deleteBooking(Booking_id).then(
        () => {
            dispatch({ type: BOOKING_DELETE_SUCCESS, payload: Booking_id });
            return Promise.resolve();
        },
        (error) => {
            dispatch({ type: BOOKING_DELETE_FAIL });
            dispatch({ type: SET_MESSAGE, payload: `Booking upsert failed - ${error}` });
            return Promise.reject();
        }
    );
};